// @flow

import { streamChat } from '../../../services/aiChatStream';

const TIMEOUT_MS = 10 * 60 * 1000; // 10 minutes

export async function startReportChatStream({
  threadId,
  prompt,
  additionalData,
  onEvent,
  onError,
  onClose,
}: {
  threadId: string,
  prompt: string,
  additionalData?: Array<{ type: string, format: string, data: string }>,
  onEvent: (status: string, data: any) => void,
  onError: (message: string) => void,
  onClose: () => void,
}): Promise<{ cancel: () => void }> {
  if (!threadId || !prompt) {
    throw new Error('threadId and prompt are required');
  }

  const payload = {
    message: prompt,
    resourceOverride: 'report-chat',
    ...(additionalData && { additionalData }),
  };

  return await streamChat(
    threadId,
    payload,
    {
      onCustomEvent: (eventPayload) => {
        const { status, data } = eventPayload || {};
        if (status && typeof onEvent === 'function') {
          onEvent(status, data);
        }
      },
      onError: (message) => {
        if (typeof onError === 'function') {
          onError(message);
        }
      },
      onClose: () => {
        if (typeof onClose === 'function') {
          onClose();
        }
      },
    },
    { timeoutMs: TIMEOUT_MS }
  );
}
